import { ChangeDetectionStrategy, Component } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { RootParams } from '@ftr/api-shared'

@Component({
  selector: 'ftr-external-login-page',
  template: '<ftr-external-login [authorizationCode]="authorizationCode" [state]="state" />',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ExternalLoginPage {
  authorizationCode: string
  state: string

  constructor(route: ActivatedRoute) {
    this.authorizationCode = route.snapshot.queryParamMap.get(RootParams.AuthorizationCode)!
    this.state = route.snapshot.queryParamMap.get(RootParams.State)!
  }
}
